module.exports = {"230307001":"麻山街道","230307198":"麻山区（镇）直辖地域"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230307.json
// module id = 654
// module chunks = 0